import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, parse } from "date-fns";
import calendarImage from "../images/calendar_month.svg";
import { ErrorMessage } from "formik";

const DatePickerWithIcon = ({ value, onChange, placeholder = "DD-MM-YYYY" }) => {
  // Convert stored dd-MM-yyyy string into Date object for DatePicker
  const parseToDate = (val) => {
    if (!val) return null;
    return parse(val, "dd-MM-yyyy", new Date());
  };

  return (
    <div className="form-group">
      <label htmlFor="dob" className="form-label">
        Date of Birth
      </label>
      <div className="input-group position-relative custom-date-wrapper">
        <DatePicker
          id="dob"
          className="form-control"
          selected={parseToDate(value)}
          onChange={(date) => {
            if (date) {
              onChange(format(date, "dd-MM-yyyy")); // pass dd-MM-yyyy back
            } else {
              onChange("");
            }
          }}
          dateFormat="dd-MM-yyyy"
          placeholderText={placeholder}
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"

        />

        <span
          className="passwordicon calendericon"
          style={{ cursor: "pointer", position: "absolute", right: "10px", top: "100%", transform: "translateY(-2%)" }}
        >
          <img
            src={calendarImage}
            alt="calendar icon"
            onClick={() => document.getElementById("dob").focus()} // open picker on icon click
          />
        </span>
      </div>

      <ErrorMessage name="dob" component="div" className="text-danger mt-1" />
    </div>
  );
};

export default DatePickerWithIcon;


// import React from "react";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { format, parse, isValid } from "date-fns";
// import calendarImage from "../images/calendar_month.svg";
// import { ErrorMessage } from "formik";

// const DatePickerInput = ({
//   selectedDate,
//   minDate,
//   maxDate,
//   onChange,
//   disable = false,
//   placeholder = "DD-MM-YYYY",
//   name = "dob", // default field name
//   label = "Date of Birth",
// }) => {
//   // Convert stored dd-MM-yyyy string into Date object for DatePicker
//   const parseToDate = (val) => {
//     if (!val) return null;
//     return parse(val, "dd-MM-yyyy", new Date());
//   };

//   const toDateObject = (val) => {
//     if (!val) return null;

//     // Case 1: Already a Date
//     if (val instanceof Date) return isValid(val) ? val : null;

//     // Case 2: ISO string (from DB or API)
//     if (typeof val === "string" && val.includes("T")) {
//       const d = new Date(val);
//       return isValid(d) ? d : null;
//     }

//     // Case 3: dd-MM-yyyy string
//     if (typeof val === "string") {
//       const d = parse(val, "dd-MM-yyyy", new Date());
//       return isValid(d) ? d : null;
//     }

//     return null;
//   };

//   return (
//     <div className="form-group">
//       <div className="input-group position-relative custom-date-wrapper">
//         <DatePicker
//           id={name}
//           name={name}
//           className="form-control"
//           // selected={
//           //   selectedDate
//           //     ? (() => {
//           //         const parsed = parse(selectedDate, "dd-MM-yyyy", new Date());
//           //         return isValid(parsed) ? parsed : null; // only return if valid
//           //       })()
//           //     : null
//           // }
//           selected={toDateObject(selectedDate)}
//           onChange={(date) => {
//             if (date instanceof Date && isValid(date)) {
//               onChange(format(date, "dd-MM-yyyy")); // send back string
//             } else {
//               onChange(""); // clear on invalid
//             }
//           }}
//           dateFormat="dd-MM-yyyy"
//           placeholderText={placeholder}
//           minDate={minDate ? new Date(minDate) : null}
//           maxDate={maxDate ? new Date(maxDate) : null}
//           disabled={disable}
//         />

//         <span
//           className="passwordicon calendericon"
//           style={{
//             cursor: disable ? "not-allowed" : "pointer",
//             position: "absolute",
//             right: "10px",
//             top: "100%",
//             transform: "translateY(-10%)",
//           }}
//         >
//           <img
//             src={calendarImage}
//             alt="calendar icon"
//             onClick={() => {
//               if (!disable) {
//                 document.getElementById(name).focus();
//               }
//             }}
//           />
//         </span>
//       </div>

//         <ErrorMessage name="dob" component="div" className="text-danger mt-1" />
//     </div>
//   );
// };

// export default DatePickerInput;

